<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="飞书群">
        <el-tag v-if="formLabelAlign.chat_id!=null" style="margin-right:10px">{{ chatname }}</el-tag>
        <el-button type="primary" size="mini" @click="chooseanon">选择飞书群</el-button>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          v-model="formLabelAlign.error_log_type_main"
          default-first-option
          filterable
          loading-text="加载中"
          :loading="loading"
          placeholder="请选择"
          @keyup.native="handleSelectChange"
        >
          <el-option
            v-for="item in options"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="quedwr">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择飞书群"
      :visible.sync="dialogVisible"
      width="40%"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <chooseanondialog ref="chooseanondialogview" @callabck="callabck" />
    </el-dialog>
  </div>
</template>

<script>
import { geterrortypeList, createerroralarm, updateerroralarm, feishuChatGetErrorTypeList } from '@/api/sourceMaterial.js'
import chooseanondialog from './chooseanondialog.vue'
export default {
  components: {
    chooseanondialog
  },
  data() {
    return {
      sendtype: null,
      labelPosition: 'right',
      formLabelAlign: {
        chat_id: null,
        error_log_type_main: null
      },
      options: [],
      chatname: '',
      dialogVisible: false,
      ids: null,
      loading: false,
      keywordname: '',
      page: {
        page: 1,
        page_size: 10
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async handleSelectChange(e) {
      if (this.timer) {
        clearTimeout(this.timer) // 清除之前的计时器
      }
      this.loading = true
      this.timer = setTimeout(async() => {
        console.log(1, e.target.value)
        this.keywordname = e.target.value
        const data = {
          name: this.keywordname,
          ...this.page
        }
        const datas = await feishuChatGetErrorTypeList(data)
        this.options = datas.data.list
        this.loading = false
      }, 1000) // 等待1秒执行
    },
    async  send(type, item) {
      await this.typelist()
      this.sendtype = type
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('新增')
      } else {
        this.ids = item.id
        this.formLabelAlign.chat_id = item.chat_id
        this.formLabelAlign.error_log_type_main = item.error_log_type_main
        this.chatname = item.chat_name
        let ss = true
        this.options.forEach(async(items) => {
          if (items.type === this.formLabelAlign.error_log_type_main) {
            ss = false
          }
        })
        if (ss) {
          const data = {
            name: item.error_log_type_main_text,
            ...this.page
          }
          const datas = await feishuChatGetErrorTypeList(data)
          this.options = datas.data.list
        }
        console.log('编辑', item, this.options)
      }
    },
    async typelist() {
      const data = await geterrortypeList()
      this.options = data.data.list
      console.log('data', data)
    },
    chooseanon() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.chooseanondialogview.send()
      })
    },
    callabck(item) {
      this.dialogVisible = false
      this.formLabelAlign.chat_id = item.chatId
      this.chatname = item.name
      console.log('item', item)
    },
    async quedwr() {
      if (this.formLabelAlign.chat_id === null) {
        this.$message({
          type: 'error',
          message: '请选择飞书群'
        })
        return
      }
      if (this.formLabelAlign.error_log_type_main === null) {
        this.$message({
          type: 'error',
          message: '请选择类型'
        })
        return
      }
      if (this.sendtype === 1) {
        const data = await createerroralarm(this.formLabelAlign)
        this.$message({
          type: 'success',
          message: '新增成功!'
        })
        this.$emit('updata')
        console.log('data', data)
      } else {
        const data = await updateerroralarm({ ...this.formLabelAlign, id: this.ids })
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.$emit('updata')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
